window.getAbsoluteUrl = (function() {
    var a;

    return function(url) {
        if(!a) a = document.createElement('a');
        a.href = url;

        return a.href;
    };
})();

var obj = {
    title: "《天谕》生日快乐！",
    desc: "欢迎您来到《天谕》周年庆典的现场，游园赢取限量道具周边，同贺天谕周年生日！",
    pic: getAbsoluteUrl(require('../images/share.jpg')),
    url: window.location.href
};

var weiboobj = {
    title: obj.title,
    desc: encodeURIComponent(obj.desc),
    pic: encodeURIComponent(obj.pic),
    url: encodeURIComponent(obj.url)
};


$('.share-btn').click(function (event) {
    var id = $(this).data("id");
    switch (id) {
        case "yx":
            snsShare.init(obj);
            snsShare.toYixin();
            break;
        case "xl":
            snsShare.init(weiboobj);
            snsShare.toSinaWeibo();
            break;
        case "wx":
            snsShare.init(obj);
            var url="http://res.nie.netease.com/comm/js/nie/util/share/api/index.html?url="+window.location.href;
            window.open(url,'','width='+640+',height='+480);
            break;
    }
});

$(".f-share-icon").hover(
    function(){
        $(".f-share-icon").addClass("active");
    },
    function(){
        $(".f-share-icon").removeClass("active");
    }
);


//////////////////
// WEBPACK FOOTER
// ./pages/anniversary/js/share.js
// module id = 1
// module chunks = 0 1 2 4